import {ReportTranslationsType} from './ReportTranslationsType';

export const enReportTranslations: ReportTranslationsType = {
  'report.modal.title': 'Campaign Report Generation',
  'report.modal.error.title': 'Error',
  'report.modal.error.text': 'An error occurred during the report generation',
  'report.modal.selector.text':
    'Generating a campaign report may take several minutes. The download will start automatically once the operation is complete.',
  'report.modal.error.button': 'Close',
  'report.modal.button': 'Download',
};
